import { Button } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import CheckIcon from "@mui/icons-material/Check";
import ListIcon from "@mui/icons-material/List";
import { proposalEligibilityStatus } from "../../../Constants";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import service from "../../../Helpers/gifservices";
import { useDispatch } from "react-redux";
import { setApplicant, setAs } from "../../../../../store/applicantsSlice";
import { setColleagues, setProposal } from "../../../../../store/proposalSlice";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  button: {
    marginBottom: 2,
    justifyContent: "left",
  },
  approveButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.green.hover,
    },
    color: theme.palette.gif.green.color,
    backgroundColor: theme.palette.gif.green.background,
  },
  unLockButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
  },
  viewButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
  },
}));

const TableActions = (props) => {
  const classes = useStyles();
  const {
    createPDF,
    allowChange,
    actionsType,
    updateProposalStatus,
    proposalId,
    canApprove
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const gotoProposal = () => {
    service.getProposalData(proposalId).then(async (proposal) => {
      const propsosalApplicants = await service.getProposalsApplicants({
        proposalId,
      });
      const retrivedApplicants = propsosalApplicants.applicantsDetails.map(
        (ad) => ({
          email: ad.emailadress,
          name: ad.applicant.name,
          id: ad.applicant.id,
        })
      );
      const proposalLeaderEmail = retrivedApplicants.filter(
        (a) => a.id === proposal.applicantLeaderId
      )[0].email;

      dispatch(setApplicant({}));
      dispatch(setProposal(proposal));
      dispatch(setColleagues(retrivedApplicants));
      dispatch(setAs(proposalLeaderEmail));
      history.push("/applicantsportal");
    });
  };

  return (
    <>
      {actionsType === "waiting" ? (
        <>
          <Button
            fullWidth
            startIcon={<CheckIcon/>}
            className={`${classes.approveButton} ${classes.button}`}
            size="small"
            disabled={!allowChange}
            onClick={() =>
              updateProposalStatus(
                proposalId,
                proposalEligibilityStatus.approvedByRA
              )
            }
          >
            Approve & Submit to GIF
          </Button>
          <Button
            fullWidth
            startIcon={<LockOpenIcon />}
            className={`${classes.unLockButton} ${classes.button}`}
            size="small"
            onClick={() =>
              updateProposalStatus(
                proposalId,
                proposalEligibilityStatus.unlockedByRA
              )
            }
          >
            Unlock for changes
          </Button>
          <Button
            fullWidth
            startIcon={<ListIcon />}
            className={classes.viewButton}
            size="small"
            onClick={gotoProposal}
          >
            View Proposal
          </Button>
        </>
      ) : (
        <Button
          fullWidth
          startIcon={<ListIcon />}
          className={classes.viewButton}
          size="small"
          onClick={createPDF}
        >
          View Proposal
        </Button>
      )}
    </>
  );
};

export default TableActions;
